import { Auth } from "components/Parts/Organisms/Auth";
import { LicensePage } from "components/Parts/Organisms/LicensePage";
import React from "react";

export const License = React.memo(() => (
  <Auth>
    <LicensePage />
  </Auth>
));
